import { DatePipe } from '@angular/common';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Email, OtpRequest } from 'src/app/features/login/login';
import { BaseResponse } from 'src/app/model/response/base-response';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LoginService } from '../login.service';


@Component({
    selector: 'app-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['../login.component.scss', './otp.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class OtpComponent implements OnDestroy{

  public page: string |null;
  otp:string='';
  otpArray:string[]=[];
  email!: string;
  resent: boolean=false;
  formOtp=new FormGroup({})

  @ViewChild("input") input?: any;

  // unsubscribe from subscription
  private theEnd$ = new Subject<void>();

  constructor( private route: ActivatedRoute, private loginService: LoginService,
    private router: Router,private localStorageS:LocalStorageService, private dateP:DatePipe) {
    this.page = this.route.snapshot.paramMap.get('route');
    //this.email = localStorageS.getMail();
    this.isResent=Boolean(localStorage.getItem(`RSOTP`))
    console.log(this.isResent)
    if(this.isResent==null){
      this.isResent==false
      localStorage.setItem(`RSOTP`,'false')
    }
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  formHaveErrors: boolean = false;
  errMsg: string = '';
  rispReset!: BaseResponse;
  isResent:boolean;
  wait:boolean=false;

  // ngAfterViewInit() {
  //   this.input.nativeElement.focus();
  // }

  tabChange(val:any,value?:any){
    console.log(value);
    let ele = document.querySelectorAll('input');
    if(value.keyCode==8){
      ele[val-2].focus()
      ele[val-2].select()
      this.otpArray[val-1]= ''
    }else
    if(value.keyCode==37){
      ele[val-2].focus()
      ele[val-2].select()
    }else
    if(value.keyCode==39||value.keyCode==32){
      ele[val].focus()
      ele[val].select()
    }else
    if(value.keyCode>=48&&value.keyCode<=57 || value.keyCode>=96&&value.keyCode<=105){
      if(val<=6){
        ele[val-1].value=value.key
        ele[val].focus()
        ele[val].select()

        this.otpArray[val-1]= ele[val-1].value
      }
      console.log(this.otpArray)
      }else if(value.keyCode==224||value.keyCode==86){
        let clipboardData = value.clipboardData ;
        var pastedData =clipboardData.getData('Text');

        ele[val-1].value=pastedData[val-1];

      }
      else{
        ele[val-1].value='';
      }
    }

  handlePaste(e:any){
    let ele = document.querySelectorAll('input');
    let clipboardData = e.clipboardData ;
    if(clipboardData){
     var pastedData =clipboardData.getData('Text');
    }
    console.log(pastedData)
    for (var i = 0; i < 6; i++) {
      ele[i].value=pastedData[i];
      this.otpArray[i]=pastedData[i];
    }
    this.tabChange(e);
  }



  otpSubmit(){
    this.otp=this.input?.value || '';
    console.warn(this.otp)

    if(this.otp==''){
      this.formHaveErrors=true;
      this.errMsg='Inserisci un otp valido';
      return;
    }if(this.email==''){
      this.formHaveErrors=true;
      this.errMsg="L'email non è valida torna indietro";
      return;
    }

    let request:OtpRequest = {
      email: this.email,
      otpCode: this.otp,
    }

    this.loginService.checkOtp(request).pipe(takeUntil(this.theEnd$)).subscribe({
      next:(response:BaseResponse)=>{
        if(response.success==true){
          //this.localStorageS.setOtp(this.otp);
          this.router.navigate(['/login/password/reset']);

        }
      },
      error:(response:any)=>{
        this.formHaveErrors=true;
        this.errMsg=response.error;
        console.log(response);
      }
    })
    console.log(this.otp)


  }

  resend(){

     this.isResent=Boolean(localStorage.getItem(`RSOTP`))

    // let currentDate = new Date()

    // let minutes=Number(localStorage.getItem(`OM`))
    // let hour=Number(localStorage.getItem(`OH`))

    // console.error(minutes,hour)

    // if(minutes==0){
    //   if(hour==0){
    //     this.isResent=false
    //     localStorage.setItem(`RSOTP`,'false')
    //   }
    // }else{

    // let resultM=minutes-Number(currentDate.getMinutes())
    // let resultH=hour-Number(currentDate.getHours())

    // console.error(resultH,resultM)

    // if(resultM==-2&&resultH==0){
    //   this.isResent=false
    //   localStorage.removeItem(`OM`)
    //   localStorage.removeItem(`OH`)
    //   localStorage.setItem(`RSOTP`,'false')
    // }else{
    //   this.isResent=true
    //   localStorage.setItem(`RSOTP`,'true')
    //   this.wait=true;
    //   setTimeout(()=>{
    //     this.wait=false;
    //   },15000)
    // }

    //}

    if(!this.isResent){

      let emailObj : Email = {
            email:this.email
      }



      this.loginService.sendOtp(emailObj).pipe(takeUntil(this.theEnd$)).subscribe({
        next:(response:boolean)=>{
          console.log(response)
          if(response==true){
            this.resent= true;
            localStorage.setItem(`RSOTP`,'true')
            setTimeout(()=>{
              this.resent=false;
            },5000)
          }
        },
        error:(response:any)=>{
          console.error('Error while processing');
          console.error(response);
          this.formHaveErrors = true;
          this.errMsg = response.error;
        }
      });

    }
  }

}
